import { render, staticRenderFns } from "./Vehicle.vue?vue&type=template&id=f0df4462&scoped=true&"
import script from "./Vehicle.vue?vue&type=script&lang=js&"
export * from "./Vehicle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0df4462",
  null
  
)

export default component.exports